<template>
  <!-- 弹出层组件 -->
  <transition name="popup-fade">
    <div class="mobile-popup" v-if="visible">
      <!-- 遮罩层 -->
      <div 
        class="popup-mask" 
        @click="handleMaskClick"
        :style="{ backgroundColor: maskColor }"
      ></div>
      
      <!-- 内容容器 -->
      <div 
        class="popup-content" 
        :style="{ 
          width: '100%', 
          maxHeight: contentMaxHeight,
          borderRadius: borderRadius + 'px'
        }"
      >
        <!-- 关闭按钮 -->
        <div class="popup-close" @click="handleClose" v-if="showClose">
          ✕
        </div>
        
        <!-- 插槽：自定义弹出层内容 -->
        <div class="popup-body">
          <img :src="imageSrc" alt="" class="imm">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MobilePopup',
  props: {
    // 是否显示弹出层
    visible: {
      type: Boolean,
      default: false
    },
    // 是否点击遮罩关闭
    closeOnMaskClick: {
      type: Boolean,
      default: true
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 遮罩层颜色
    maskColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.5)'
    },
    // 内容区宽度
    contentWidth: {
      type: String,
      default: '100%'
    },
    // 内容区最大高度
    contentMaxHeight: {
      type: String,
      default: '70vh'
    },
    // 圆角大小
    borderRadius: {
      type: Number,
      default: 12
    },
    // 图片路径
    imageSrc: {
      type: String,
      default: '@assets/actimg/hdgz.jpg'
    }
  },
  methods: {
    // 点击遮罩处理
    handleMaskClick() {
      if (this.closeOnMaskClick) {
        this.handleClose()
      }
    },
    // 关闭弹出层
    handleClose() {
      // 向父组件发送关闭事件
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* 弹出层整体容器 */
.mobile-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

/* 遮罩层样式 */
.popup-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: opacity 0.3s ease;
}

/* 内容区样式 */
.popup-content {
  position: relative;
  /* background: #ffffff; */
  /* padding: 20px; */
  box-sizing: border-box;
  overflow-y: auto;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateY(20px);
  /* opacity: 0; */
}

/* 过渡动画 */
.popup-fade-enter-active .popup-content,
.popup-fade-leave-active .popup-content {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.popup-fade-enter .popup-mask,
.popup-fade-leave-to .popup-mask {
  opacity: 0;
}

.popup-fade-enter-to .popup-content {
  transform: translateY(0);
  opacity: 1;
}

.popup-fade-leave-to .popup-content {
  transform: translateY(20px);
  opacity: 0;
}

/* 关闭按钮样式 */
.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 18px;
  color: #999999;
  cursor: pointer;
  z-index: 1;
}

.popup-close:hover {
  color: #666666;
}

/* 内容主体区域 */
.popup-body {
  margin-top: 8px; /* 给关闭按钮留出空间 */
  
}
.imm{
    width: 100%;
}
</style>